import { Navigate } from "react-router-dom";
import DasBoardPage from "../pages/dasBoardPage";
import { isTokenExpiredMidnight, handleSessionExpired } from "../httpInterSeptur/HttpInterSeptur";
import { getToken2 } from "../utils/localStorage";

function PrivateRoute({ componet: componet, isAuthenticated, ...rest }) {
  const token = getToken2();
  if (token && isTokenExpiredMidnight(token)) {
    handleSessionExpired();
    return <Navigate to="/loginPage" replace />;
  }
  return isAuthenticated ? <DasBoardPage /> : <Navigate to="/loginPage" replace />;
}
export default PrivateRoute;
